module.exports = __webpack_public_path__ + "static/media/service13.49d3cb74.jpg";